import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <Paper elevation={1} sx={{ p: { xs: 3, md: 5 } }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
            Privacy Policy
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Last updated: April 2, 2026
          </Typography>

          <Box sx={{ mt: 3, '& h6': { mt: 3, mb: 1, fontWeight: 600 }, '& p': { mb: 2, lineHeight: 1.8 } }}>

            <Typography variant="h6">1. Introduction</Typography>
            <Typography>
              JyotishSastra ("we", "our", "us") operates the website jyotishsastra.com and the JyotishSastra
              mobile application (collectively, the "Service"). This Privacy Policy explains how we collect,
              use, disclose, and safeguard your information when you use our Service.
            </Typography>

            <Typography variant="h6">2. Information We Collect</Typography>
            <Typography>
              <strong>Account Information:</strong> When you register, we collect your name, email address,
              phone number, and password. Astrologers additionally provide professional credentials and
              profile information.
            </Typography>
            <Typography>
              <strong>Birth Data:</strong> For astrological calculations (kundli, horoscope, matching), we
              collect date of birth, time of birth, and place of birth. This data is used solely for
              generating astrological charts and is stored securely.
            </Typography>
            <Typography>
              <strong>Payment Information:</strong> Wallet transactions and consultation payments are processed
              through our payment gateway. We store transaction records but do not store full card or bank
              account details on our servers.
            </Typography>
            <Typography>
              <strong>Usage Data:</strong> We collect anonymous usage analytics (page views, feature usage)
              via Umami, a privacy-focused, self-hosted analytics platform. No personally identifiable
              information is sent to third-party analytics services.
            </Typography>
            <Typography>
              <strong>Device Information:</strong> When you enable push notifications, we store a device token
              (Firebase Cloud Messaging token) to deliver notifications. Device tokens are deleted when you
              log out or disable notifications.
            </Typography>

            <Typography variant="h6">3. How We Use Your Information</Typography>
            <Typography>
              We use your information to: provide and maintain the Service; generate astrological charts and
              reports; facilitate consultations between users and astrologers; process payments and maintain
              wallet balances; send push notifications (consultation reminders, daily panchanga, promotional
              offers — configurable in your notification preferences); improve and personalize your experience;
              and comply with legal obligations.
            </Typography>

            <Typography variant="h6">4. Push Notifications</Typography>
            <Typography>
              We use Firebase Cloud Messaging (FCM) by Google to deliver push notifications. Notification
              categories include: consultation requests, slot reminders, daily panchanga, and promotional
              messages. You can control which categories you receive in Settings &gt; Notification Preferences.
              Consultation-related notifications cannot be disabled as they are essential to the service.
            </Typography>

            <Typography variant="h6">5. Data Sharing</Typography>
            <Typography>
              We do not sell your personal data. We share information only with: astrologers you choose to
              consult with (limited to information necessary for the consultation); payment gateway providers
              for processing transactions; Firebase Cloud Messaging for push notification delivery (device
              tokens only, no personal data in notification payloads); and law enforcement when required by law.
            </Typography>

            <Typography variant="h6">6. Data Storage and Security</Typography>
            <Typography>
              Your data is stored on secure servers hosted on DigitalOcean infrastructure. All data in
              transit is encrypted via HTTPS/TLS. We use JWT-based authentication, bcrypt password hashing,
              and role-based access control. Database backups are encrypted.
            </Typography>

            <Typography variant="h6">7. Data Retention</Typography>
            <Typography>
              Account data is retained as long as your account is active. Consultation records and chat
              history are retained for service quality and dispute resolution. Astrological charts (kundli)
              are retained for your convenience until you request deletion. Push notification device tokens
              are deleted on logout and cleaned up automatically if inactive for 30 days.
            </Typography>

            <Typography variant="h6">8. Your Rights</Typography>
            <Typography>
              You have the right to: access your personal data; correct inaccurate data; request deletion
              of your account and associated data; export your astrological charts; opt out of promotional
              notifications; and withdraw consent for data processing. To exercise these rights, contact us
              at the email below.
            </Typography>

            <Typography variant="h6">9. Cookies and Local Storage</Typography>
            <Typography>
              We use browser local storage for authentication tokens, notification preferences, and offline
              functionality (cached charts, message queue). We use a consent banner for analytics tracking.
              No third-party tracking cookies are used.
            </Typography>

            <Typography variant="h6">10. Children's Privacy</Typography>
            <Typography>
              Our Service is not intended for children under 13. We do not knowingly collect personal
              information from children under 13.
            </Typography>

            <Typography variant="h6">11. Changes to This Policy</Typography>
            <Typography>
              We may update this Privacy Policy from time to time. We will notify you of any changes by
              posting the new Privacy Policy on this page and updating the "Last updated" date.
            </Typography>

            <Typography variant="h6">12. Contact Us</Typography>
            <Typography>
              If you have questions about this Privacy Policy, please contact us at:
              <br />
              Email: support@jyotishsastra.com
              <br />
              Website: https://jyotishsastra.com
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
